import type { DeviceRegistryCommand } from '@tryiris-ai/common.protojs/agent/v1/agent';

/** @internal */
export const calculateDefaults = (
  commandMap: Record<number, DeviceRegistryCommand>
): Record<number, number> => {
  const defaultsMap: Record<number, number> = {};

  Object.entries(commandMap).forEach(([key, cmd]) => {
    let defaultValue;

    if (cmd.value !== undefined) {
      defaultValue = cmd.value.default;

      cmd.value.labels.forEach((label) => {
        if (label.default) {
          defaultValue = label.value;
        }
      });
    } else if (cmd.select !== undefined) {
      cmd.select.options.forEach((option, index) => {
        if (option.default) {
          defaultValue = index;
        }
      });
    }

    if (defaultValue !== undefined) {
      defaultsMap[Number(key)] = defaultValue;
    }
  });

  return defaultsMap;
};
